import React, { useState, useEffect } from "react";
import quotes from "../constants/quotes";
import "./Preloader.css";
import { Loader } from "rsuite";

const LOGO_LIGHT = require("../assets/img/wmp-logo-03.png");
const LOGO_DARK = require("../assets/img/wmp-logo-01.png");

const Preloader = ({ text, inline, overlay, logo, dark = false, textOverride, active = true }) => {
  const [quoteIndex, setQuoteIndex] = useState(0);
  const [animationKey, setAnimationKey] = useState(0);
  const [ellipsis, setEllipsis] = useState("");

  useEffect(() => {
    if (!active) return;
    const timer = setInterval(() => {
      setQuoteIndex((prevIndex) => {
        let newIndex;
        do {
          newIndex = getRandomQuoteIndex();
        } while (newIndex === prevIndex);
        return newIndex;
      });
      setAnimationKey((prevKey) => prevKey + 1);
    }, 6000);
    return () => clearInterval(timer);
  }, [active]);

  useEffect(() => {
    if (!active) return;
    const ellipsisTimer = setInterval(() => {
      setEllipsis((prevEllipsis) => {
        if (prevEllipsis.length < 3) {
          return prevEllipsis + ".";
        } else {
          return "";
        }
      });
    }, 700);
    return () => clearInterval(ellipsisTimer);
  }, [active]);

  const getRandomQuoteIndex = () => {
    return Math.floor(Math.random() * quotes.length);
  };

  if (!active) return null;

  return (
    <div
      style={overlay ? {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 10000,
        height: inline ? "100%" : "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 1)"
      } : {
        width: "100%",
        height: inline ? "100%" : "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <div style={{ textAlign: 'center' }}>
        {logo ? (
          <img src={dark ? LOGO_DARK : LOGO_LIGHT}
               style={{
                 display: 'block',
                 marginLeft: 'auto',
                 marginRight: 'auto',
                 maxWidth: '300px',
               }}
                alt="Watch My Page"
          />
        ) : (
          <Loader size="sm" speed="slow" />
        )}
        <br/>
        {text && (
          <div className="quote-container">
            <h4>{textOverride ? textOverride : "Loading"}{ellipsis}</h4>
            <br/><br/>
            <span
              className={`quote-text fade-rotate-${animationKey % 2}`}
              key={quoteIndex}
            >
              {quotes[quoteIndex]}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Preloader;
